module.exports = __webpack_public_path__ + "static/media/12n.55e30592.svg";